import {defineStore} from "pinia";
import {injectEnv} from "@fd/Environment.ts";
import {SelectHierarchy} from "@t/ui/SelectHierarchy.ts";
import {ApplyTemplateResponse, TemplateVariables} from "@t/template/Templates.ts";
import {emptyMap, injectContext, toQueryString} from "@t/fd/AppContext.ts";

export const useTemplateStore = defineStore('template', () => {

	const env = injectEnv();
	const ctx = injectContext();


	const applicableTemplatesCache = new Map<string, SelectHierarchy>();

	async function loadApplicableTemplates(useFor: string|number, useForSpec?: string|number):Promise<SelectHierarchy|null> {
		const key = useFor + (useForSpec ? "" : "-" + useForSpec);
		if (applicableTemplatesCache.has(key)) return applicableTemplatesCache.get(key);
		let ep:string = "api/templates/applicable";
		ep = env.net.urlParam(ep, "useFor", useFor);
		if (useForSpec) ep = env.net.urlParam(ep, "useForSpec", useForSpec);
		const response = await env.net.fetch(ep);
		if (response.ok) {
			const hierarchy = await response.json();
			applicableTemplatesCache.set(key, hierarchy);
			return hierarchy;
		}
		return null;
	}

	async function applyTemplate(templateId:number|string, vars:TemplateVariables):Promise<string|null> {
		let ep:string = "api/templates/"+templateId+"/apply";
		const c = ctx.value;
		const qs = toQueryString(c);
		if (qs) ep += "?"+ qs;
		const response = await env.net.fetch(ep, "POST", vars);
		if (response.ok) {
			const result = await response.json() as ApplyTemplateResponse;
			return result.output;
		}
		return null;
	}

	return {
		loadApplicableTemplates,
		applyTemplate
	}
});